import { render, staticRenderFns } from "./policies.vue?vue&type=template&id=3b75cf3e&scoped=true"
import script from "./policies.vue?vue&type=script&lang=ts"
export * from "./policies.vue?vue&type=script&lang=ts"
import style0 from "./policies.vue?vue&type=style&index=0&id=3b75cf3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b75cf3e",
  null
  
)

export default component.exports